import { Injectable } from "@angular/core";
import mapper from "object-mapper";

@Injectable({
	providedIn: "root"
})
export class ObjectMappingService {
	constructor() {}
	static transform<T>(src: any, map: any): T {
		return <T>mapper(src, map);
	}
}
